import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-sidebar-new',
  templateUrl: './sidebar-new.component.html',
  styleUrls: ['./sidebar-new.component.scss']
})
export class SidebarNewComponent implements OnInit {
  @Input() enableCityWiseCreationCutOff = false;
  public config: any;
  public version: string;
  public cutoff: any;
  public isBookingCutoff: boolean;
  public bookingCutoffMessage: string;
  public isProduction: boolean;
  settingList = false;
  bigLogoURL: string;
  constructor(
      private commonService: CommonService,

      private domSanitizer: DomSanitizer,
      private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getUserInfo().subscribe();

    this.commonService.fetchConfig().subscribe((response: any) => {
      this.setSidebarConfig(response);
    });
    if (this.enableCityWiseCreationCutOff){
      this.commonService.fetchCityCutoff().subscribe((response: any) => {
        this.commonService.cityCuttoffObj.next(response.bookingTypeConfig);
      });
    }
    else{
      this.commonService.fetchCutoff().subscribe((response: any) => {
        this.cutoff = response;
        this.commonService.cuttoffObj.next(response?.bookingTypeConfig);
      });
    }

    // logo api
    this.commonService.getSmallLogo(true).subscribe(res => {
      const blob = new Blob([res.body], {type: 'jpeg'});
      const url = window.URL.createObjectURL(blob);
      this.bigLogoURL = url;
    });
  }
  getSafeUrl() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.bigLogoURL);
  }
  setSidebarConfig(configObj: any) {
    const sideBarConfig = this.commonService.getConfigForElementKey(configObj, 'Side Bar');
    this.config = {
      createBooking: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'Create Booking').config,
      },
      bulkBooking: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'Bulk Booking').config,
      },
      personal: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'Personal Booking Management').config,
        myBookings: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'My Bookings').config },
        myprofile: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'My Profile').config },
      },
      cds: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'cds').config,
        Tracking: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Tracking').config },
      },
      organization: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'Organizational Booking Management').config,
        requestView: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Request View').config },
        bookingView: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Booking View').config }
      },
      billing: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, 'Billing').config,
        billingReports: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Billing Reports').config },
        invoicing: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Invoicing').config },
        contractManagement: { config: this.commonService.getConfigForElementKey(sideBarConfig, 'Contract Management').config }
      },
      settings: {
        config: this.commonService.getConfigForElementKey(sideBarConfig, "Settings").config,
        AVA: { config: this.commonService.getConfigForElementKey(sideBarConfig, "AVA").config },
        DBVA: { config: this.commonService.getConfigForElementKey(sideBarConfig, "Designation").config },
      }

    };
    this.commonService.roleConfig.next(this.config);
  }
  showSettings(){
    this.settingList = !this.settingList;
  }

}
